import { createSlice, PayloadAction } from '@reduxjs/toolkit';
export type AdminRole = { id: number; name: string; code: string; is_system: boolean };
export type Admin = {
  id: number;
  email: string;
  role: string;
  roles: AdminRole[];
  scopes: string[];
  is_active: boolean;
  mfa_enabled: boolean;
  last_login_at: string | null;
  created_at: string;
  deactivated_at: string | null;
};

export type AdminMfaChallenge = {
  challenge_id: string;
  expires_at: string;
};

export type AdminAuthSession = {
  access_token: string;
  admin: Admin;
};
type State = {
  accessToken: string | null;
  admin: Admin | null;
  pendingChallengeId: string | null;
  challengeExpiresAt: string | null;
};
const initialState: State = {
  accessToken: null,
  admin: null,
  pendingChallengeId: null,
  challengeExpiresAt: null,
};
const slice = createSlice({
  name: 'adminAuth',
  initialState,
  reducers: {
    adminMfaStarted: (s, a: PayloadAction<AdminMfaChallenge>) => {
      s.pendingChallengeId = a.payload.challenge_id;
      s.challengeExpiresAt = a.payload.expires_at;
    },
    adminTokenReceived: (s, a: PayloadAction<AdminAuthSession>) => {
      s.accessToken = a.payload.access_token;
      s.admin = a.payload.admin;
      s.pendingChallengeId = null;
      s.challengeExpiresAt = null;
    },
    adminLoggedOut: () => initialState,
  },
});
export const { adminMfaStarted, adminTokenReceived, adminLoggedOut } = slice.actions;
export default slice.reducer;
